import {
  doc,
  collection,
  getDocs,
  updateDoc,
  query,
  where,
  setDoc,
  deleteDoc,
  getDoc,
} from "firebase/firestore";
import { db } from "./firebaseConfig";

// USER

export const getUserFirebase = async (email) => {
  const docRef = collection(db, "users");
  const q = query(docRef, where("email", "==", email));
  const querySnap = await getDocs(q);
  if (querySnap) {
    console.log(`user ${email} loaded`);
    return querySnap.docs.map((doc) => ({ ...doc.data() }));
  } else {
    console.log("No appointments document");
  }
};

export const getUsersFirebase = async () => {
  const docRef = collection(db, "users");
  const docSnap = await getDocs(docRef);
  if (docSnap) {
    return docSnap.docs.map((doc) => ({ ...doc.data() }));
  } else {
    console.log("No such document");
  }
};

export const updateUserFirebase = async (updatedUser) => {
  try {
    await setDoc(doc(db, "users", updatedUser.id), updatedUser);
    console.log("user updated");
  } catch (err) {
    console.error("updateUserFirebase: erro ao gravar no Firestore", err);
    throw err;
  }
};

// POSTS

export const createActsListFirebase = async (axis, ActsList) => {
  await setDoc(doc(db, "activities", `${axis}ActsList`), {
    [`${axis}ActsList`]: ActsList,
  });
  console.log(axis + " act list created");
};

export const getActsListsFirebase = async (axis) => {
  const docRef = doc(db, "activities", `${axis}ActsList`);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    console.log(`${axis}ActsList loaded`);
    return docSnap.data();
  } else {
    console.log("No post document");
  }
};

// Admin

export async function createMeeting(newMeeting) {
  try {
    await setDoc(doc(db, "meetings", newMeeting.id), newMeeting);
  } catch (error) {
    throw error;
  }
}

export async function deleteMeeting(meetingId) {
  if (!meetingId) {
    throw new Error("O ID do meeting é obrigatório para exclusão.");
  }

  try {
    const meetingRef = doc(db, "meetings", meetingId);
    await deleteDoc(meetingRef);
    console.log(`✅ Meeting ${meetingId} excluído com sucesso.`);
  } catch (error) {
    console.error("❌ Erro ao excluir o meeting:", error);
    throw error;
  }
}

export const createActFirebase = async (post) => {
  await setDoc(doc(db, "activities", post.id), {
    id: post.id,
    axis: post.axis,
    title: post.title,
    url: post.url,
    image: post.image,
    tags: post.tags,
    content: post.content,
    createdAt: post.createdAt,
    updatedAt: post.updatedAt,
  });
  console.log(post.title + " created");
};

export const getActFirebase = async () => {
  const docRef = collection(db, "activities");
  const q = query(docRef, where("today", "==", true));
  const querySnap = await getDocs(q);
  if (querySnap) {
    console.log(`activity loaded`);
    return querySnap.docs.map((doc) => ({ ...doc.data() }));
  } else {
    console.log("No activities document");
  }
};
